import "UI/Widget/Text";
import "UI/Widget/Forms/Control/Input";
/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Input
 */
UI.Widget.Forms.Control.Point = Class(UI.Widget.Forms.Control.Input, /** @lends UI.Widget.Forms.Control.Point.prototype */ {
    textControl: null,

    createElement: function() {
        this.$element = $("<input type='text'>");
    },

    insertElement: function() {
        var self = this;

        this.ParentCall();

        this.textControl = new UI.Widget.Text(this.parent, {
            element: this.$element
        });

        var onLiveChange = this.$control.attr("on-live-change");

        if (onLiveChange) {
            this.textControl.liveChange().on("livechange", function(args) {
                if (self.parent && Util.isFunction(self.parent[onLiveChange])) {
                    self.parent[onLiveChange](args);
                }
            });
        }

        var mask = this.$control.attr("mask");

        if (mask) {
            this.$element.mask(mask);
        }
    },

    updateElement: function(value) {
        this.$element.val(value && (value.coordinates[0] + ' ' + value.coordinates[1]) || '');
    },

    listenElement: function() {
        var self = this;

        this.$element.on("change", function() {
            var p = this.value.match(/-?[0-9]+(\.[0-9]+)?/g);
            if (p && p.length > 1) {
                p = p.map(function(v) {
                    return parseFloat(v)
                });
                self.setValue({
                    type: "Point",
                    coordinates: [p[0], p[1]]
                });
            } else {
                self.setValue(null);
            }
        });
    },

    removeElement: function() {
        this.textControl.unlink();
        this.textControl.destroy();

        this.textControl = null;

        this.ParentCall();
    }
});
